import { cva } from 'class-variance-authority'
import { cn } from '~/lib/utils'
import { isDevelopment } from '~/utils/misc'

import Icon from '~/components/Helpers/Icon'
import TertiaryLink from '~/components/UI/Buttons/TertiaryLink/TertiaryLink'

const cardVariants = cva('', {
  variants: {
    backgroundColour: {
      'ink-blue': 'bg-blue-d text-white fill-blue-d',
      'mid-blue': 'bg-blue-m text-white fill-blue-m',
      'light-blue': 'bg-blue-l-60 text-blue-d fill-blue-l-60',
      chartreuse: 'bg-char text-blue-d fill-char',
      'light-pink': 'bg-pink-60 text-blue-d fill-pink-60',
      'light-aqua': 'bg-green-60 text-blue-d fill-green-60',
      'light-purple': 'bg-purple-60 text-blue-d fill-purple-60',
      'light-orange': 'bg-orange-60 text-blue-d full-orange-60',
      'light-grey': 'bg-grey-l text-blue-d fill-grey-l',
      white: 'bg-white text-blue-d fill-white'
    }
  },
  defaultVariants: {
    backgroundColour: 'ink-blue'
  }
})

const LinkCard = ({ content, className, carousel }: CardProps) => {
  const { backgroundColour, icon, image, buttons } = content

  const button = buttons ? buttons[0] : null

  const foregroundColour = ['ink-blue', 'mid-blue'].includes(backgroundColour)
    ? 'white'
    : ['white', 'light-grey', 'chartreuse'].includes(backgroundColour) &&
        icon?.duotone
      ? 'mid-blue'
      : 'ink-blue'

  const useDuotone =
    ['white', 'light-grey', 'chartreuse'].includes(backgroundColour) &&
    (icon?.duotone || button?.strongColour ? true : false)

  const previewUrl =
    isDevelopment && !content?.image?.asset.sys.uri.startsWith('https')
      ? 'https://preview-websitemodern-uni-hull.cloud.contensis.com'
      : ''

  return (
    <div
      className={cn(
        cardVariants({ backgroundColour }),
        className,
        'relative flex !h-[500px] max-h-[500px] w-full flex-col'
      )}
    >
      {image && (
        <div className='relative grow'>
          <img
            className={cn(
              'h-full w-full object-cover',
              `${carousel ? 'max-h-[290px]' : 'max-h-[430px]'}`
            )}
            src={`${previewUrl}${image?.asset.sys.uri}`}
            alt={image?.altText}
          />
          <svg
            width='100%'
            height='100%'
            className='absolute -bottom-[1px] z-1'
          >
            <rect
              height={16}
              className={cn(
                cardVariants({ backgroundColour }),
                'lg:h-s sm:h-xs-plus w-[calc(50%-8px)] translate-y-[calc(100%-16px)] sm:w-[calc(50%-10px)] sm:translate-y-[calc(100%-20px)] lg:w-[calc(50%-12px)] lg:translate-y-[calc(100%-23px)]'
              )}
            />
            <rect
              width={16}
              height={16}
              className={cn(
                cardVariants({ backgroundColour }),
                'lg:w-s lg:h-s sm:w-xs-plus sm:h-xs-plus translate-x-[calc(50%-8px)] translate-y-[calc(100%-32px)] sm:translate-x-[calc(50%-10px)] sm:translate-y-[calc(100%-40px)] lg:translate-x-[calc(50%-12px)] lg:translate-y-[calc(100%-46px)]'
              )}
            />
            <rect
              height={16}
              className={cn(
                cardVariants({ backgroundColour }),
                'lg:h-s sm:h-xs-plus w-[calc(50%-8px)] translate-x-[calc(50%+8px)] translate-y-[calc(100%-16px)] sm:w-[calc(50%-10px)] sm:translate-x-[calc(50%+10px)] sm:translate-y-[calc(100%-20px)] lg:w-[calc(50%-12px)] lg:translate-x-[calc(50%+12px)] lg:translate-y-[calc(100%-23px)]'
              )}
            />
          </svg>
        </div>
      )}
      {icon && !image && (
        <div className='p-m flex h-full grow items-center justify-center'>
          <Icon
            icon={{ ...icon, duotone: useDuotone }}
            backgroundColour={backgroundColour}
            className='[&>img]:size-[96px]'
          />
        </div>
      )}
      {button && (
        <div className='px-s pb-s lg:px-m lg:pb-m'>
          <TertiaryLink
            data={{ ...button, strongColour: useDuotone }}
            colour={foregroundColour}
            className='mt-xs'
            // className='[&>div]:sm:ml-s [&>div]:lg:ml-m [&>div]:ml-xs [&>div]:mb-xs [&>div]:lg:mb-m [&>div]:sm:mb-s absolute bottom-0 left-0 z-[2] flex h-full w-full items-end [&_svg]:not-first:-mb-[1px] [&>div]:relative [&>div]:h-min [&>div]:w-fit'
          />
        </div>
      )}
    </div>
  )
}

export default LinkCard
